/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_OverlineInputs */

const en_dr_why_overline = /** @type {(inputs: Dr_Why_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why not a whiteboard`)
};

const id_dr_why_overline = /** @type {(inputs: Dr_Why_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenapa bukan whiteboard`)
};

/**
* | output |
* | --- |
* | "Why not a whiteboard" |
*
* @param {Dr_Why_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_overline = /** @type {((inputs?: Dr_Why_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_overline(inputs)
	return en_dr_why_overline(inputs)
});